import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'
import { spLogTags } from '@eventr/common'

export const setStatusBarStyleLight = async () => {
    if (!Capacitor.isNativePlatform()) return
    const info = await StatusBar.getInfo()
    if (info.style === Style.Light) return
    spLogTags('setStatusBarStyleLight', ['UX'])
    await StatusBar.setStyle({ style: Style.Light })
}
export const setStatusBarStyleDark = async () => {
    if (!Capacitor.isNativePlatform()) return
    const info = await StatusBar.getInfo()
    if (info.style === Style.Dark) return
    spLogTags('setStatusBarStyleDark', ['UX'])
    await StatusBar.setStyle({ style: Style.Dark })
}
